import { formatISO } from 'date-fns';

import { ExpandableFieldList } from '@/modules/home';
import { FieldsHeader } from '@/modules/home';
import { useGetHomeFields } from '@/modules/home/apiHooks';
import { getFieldStatusCounts } from '@/modules/home/components/PageContent/Operations/Fields/logic';
import { useHomePageContext } from '@/modules/home/context';
import { Loading } from '@/shared/components/atoms';
import { useStore } from '@/shared/hooks/context/createGenericContext';

const FieldOperations = () => {
  const [selectedAsset] = useStore((store) => store?.asset);

  const {
    state: { date },
  } = useHomePageContext();

  const { data, isLoading, isFetching } = useGetHomeFields({
    entityId: selectedAsset?.id,
    date: formatISO(new Date(date), { representation: 'date' }),
  });

  return (
    <div className='flex min-h-[148px] flex-col p-16 pb-0'>
      <FieldsHeader counts={data ? getFieldStatusCounts(data) : undefined} />
      {isLoading || isFetching ? (
        <div className='flex flex-grow items-center justify-center'>
          <Loading />
        </div>
      ) : (
        <ExpandableFieldList fields={data} />
      )}
    </div>
  );
};

export { FieldOperations };
